import { kebabCase } from "@@/utilities/casing";

const slugify = <T extends string = string>(input: string): T => {
    const output =
        input
            .replace(/\s+/g, "-")
            .replace(/[ÅÄ]/gi, "a")
            .replace(/Ö/gi, "o")
            .trim()
            .toLowerCase() ?? "";
    const formatted = kebabCase(output);
    if (output.endsWith("-") && !formatted.endsWith("-"))
        return (formatted + "-") as T;
    return formatted as T;
};

export { slugify };
